var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVaccines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.442,
    height: 30.247,
    viewBox: "0 0 30.442 30.247",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1235",
    "data-name": "Group 1235",
    transform: "translate(-513.803 -254.621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M517.938,284.868l-4.135-4.159,2.142-2.134.413.337,2.275-2.263-2.892-2.871,2.35-2.35,1.342,1.6,12.742-12.743,1.876,2.1a5.092,5.092,0,0,0,.524-.5,2.025,2.025,0,0,1,2-.878,1.114,1.114,0,0,0,.749-.358c2.007-1.982,3.995-3.983,6.04-6.031l.629.79c-.082.086-.224.242-.374.392-1.868,1.87-3.74,3.735-5.6,5.614a.959.959,0,0,0-.327.638,2.134,2.134,0,0,1-.947,2.142,3.886,3.886,0,0,0-.383.4l2.041,1.887-12.74,12.74,1.608,1.345L525,282.846l-2.793-2.914-2.4,2.417.3.356ZM528.362,271.7l-.705.839-3.048-3.085-1.891,1.834,2.014,1.968-.636.874-2.1-2.16-1.68,1.65,4.725,4.737,11.739-11.74-4.663-4.666-1.808,1.766,3.026,3.007-.66.814-3.049-3.079-1.837,1.8,2.031,1.95-.7.808-1.962-2.1L525.3,268.7Zm-2.595,9.117-7.872-7.873-.648.634,7.867,7.867Zm-6.3-3.238-2.135,2.136,1.648,1.686,2.2-2.2Zm-1.445,5.931.6-.629-2.788-2.785-.648.59Zm17.647-19.67c.426-.545,1.257-.838.9-1.746-.916-.244-1.187.535-1.745.976Z",
    fill: "#ee7404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M737.066,298.31c.6.587,1.179,1.072,1.66,1.641a1.859,1.859,0,0,1-.2,2.576,2.117,2.117,0,0,1-2.816-.009,1.91,1.91,0,0,1-.188-2.587,2.681,2.681,0,0,1,.194-.224C736.155,299.25,736.6,298.8,737.066,298.31Zm.082,1.407c-.335.337-.609.571-.831.847a.9.9,0,0,0,.113,1.236,1.107,1.107,0,0,0,1.374.012.9.9,0,0,0,.135-1.233C737.712,300.285,737.437,300.028,737.148,299.717Z",
    transform: "translate(-194.909 -38.479)",
    fill: "#ee7404"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaccines);
export default __webpack_public_path__ + "static/media/vaccines.f381568b2bafb9b5540b175093ab42b9.svg";
export { ForwardRef as ReactComponent };